module.exports = __webpack_public_path__ + "videos/Brand_Page_Header_Video_Neu_mit_Filter.webm";